/**
 * Page détail d'une fiche Circulation — réutilise <PedagogicalCanvas> trame Conduite.
 *
 * Route : /enseignant/cours-circulation/:slug
 */
import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import PedagogicalCanvas from '../components/teacher/PedagogicalCanvas';
import PresentationModeOverlay from '../components/teacher/PresentationMode';
import { getFicheCirculationBySlug } from '../data/teacher/fichesCirculation';
import useSeo from '../hooks/useSeo';

export default function CirculationCoursFiche() {
  const { slug } = useParams();
  const fiche = getFicheCirculationBySlug(slug);
  const [presenting, setPresenting] = useState(false);

  useSeo({
    title: fiche
      ? `${fiche.title} · ${fiche.competence} · Circulation · Code 2 Roues`
      : 'Fiche circulation introuvable',
    description: fiche?.summary || 'Fiche circulation introuvable.',
    path: `/enseignant/seance-circulation/${slug}`,
  });

  if (!fiche) {
    return (
      <div className="space-y-4 max-w-md mx-auto py-8" data-testid="fiche-circ-not-found">
        <AlertCircle className="w-10 h-10 text-muted-foreground mx-auto" />
        <h1 className="text-xl font-black text-center">Fiche circulation introuvable</h1>
        <p className="text-sm text-muted-foreground text-center">
          La fiche &laquo; {slug} &raquo; n&apos;existe pas (ou plus).
        </p>
        <div className="flex justify-center">
          <Button asChild variant="outline">
            <Link to="/enseignant/seance-circulation">
              <ArrowLeft className="w-4 h-4 mr-1.5" /> Retour Cours Circulation
            </Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid={`circulation-fiche-${fiche.slug}`}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <Link
          to="/enseignant/seance-circulation"
          className="inline-flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="w-4 h-4" /> Cours Circulation · Toutes les fiches
        </Link>
        <Link
          to={`/enseignant/seance-circulation/${fiche.slug}/presenter`}
          data-testid="open-presentation-pro"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs sm:text-sm font-black uppercase tracking-wider text-white shadow-lg transition-all hover:scale-105"
          style={{ background: 'linear-gradient(135deg, #cf2031 0%, #7c3aed 100%)' }}
        >
          🎬 Mode Pro · Studio
          <span className="text-[10px] font-black uppercase tracking-widest px-1.5 py-0.5 bg-white/20 rounded-md">NEW</span>
        </Link>
      </div>

      <PedagogicalCanvas
        trameId="conduite"
        title={fiche.title}
        kicker={fiche.kicker}
        meta={fiche.meta}
        steps={fiche.steps}
        accent={fiche.accent}
        testid={`canevas-${fiche.slug}`}
        onPresentToggle={() => setPresenting(true)}
      />

      {presenting && (
        <PresentationModeOverlay
          trameId="conduite"
          title={fiche.title}
          kicker={fiche.kicker}
          meta={fiche.meta}
          steps={fiche.steps}
          onClose={() => setPresenting(false)}
        />
      )}
    </div>
  );
}
